import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { IconArrow } from "../components/Icon";

export function NotFound() {
  return (
    <>
      <SEO
        title="Page introuvable (404) - Anexya"
        description="La page que vous cherchez n'existe pas ou a été déplacée."
        path="/404"
        noindex
      />
      <section className="gradient-hero min-h-[70vh] grid place-items-center">
        <div className="container-page text-center py-20">
          <div className="font-display font-extrabold text-7xl sm:text-8xl text-brand-600">
            404
          </div>
          <h1 className="mt-4">Cette page a été balayée…</h1>
          <p className="mt-4 max-w-xl mx-auto text-ink-muted text-lg">
            Le lien que vous avez suivi n'existe pas ou a été déplacé. Retrouvez nos services
            d'entretien à Vichy depuis la page d'accueil.
          </p>
          <div className="mt-8 flex flex-wrap gap-3 justify-center">
            <Link to="/" className="btn-primary">
              Retour à l'accueil <IconArrow className="h-4 w-4" />
            </Link>
            <Link to="/contact" className="btn-ghost">
              Nous contacter
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
